import React, { useState, useRef } from "react";
import { Box, Typography, Button, TextField, Grid } from "@mui/material";
import BackgroundPaws from "../../assets/images/services/backgroundPaws.png";
import Underline from "../../assets/images/services/underline.png";
import Phone from "../../assets/images/phone.png";
import Mail from "../../assets/images/mail.svg";
import SendMessage from "../../assets/images/sendmessage.png";
import Facebook from "../../assets/icons/Facebook.svg";
import Instagram from "../../assets/icons/Instagram.svg";

export default function Services() {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    message: "",
  });

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };
  return (
    <Box sx={{ overflow: "hidden" }}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
          height: { lg: "calc(100vh - 160px)", xs: "calc(100dvh - 330px)" },
          padding: "10px 20px",
          width: { xs: "calc(100dvw - 40px)" },
          marginTop: { lg: "120px", xs: "290px" },
          overflowY: "auto",
          overflowX: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${BackgroundPaws}), url(${BackgroundPaws})`,
            backgroundRepeat: "no-repeat, no-repeat",
            backgroundPosition: "top right, -200px 580px",
            backgroundSize: "auto 30%, auto 30%",
            opacity: 0.4,
            zIndex: -1,
          },
        }}
      >
        {/* Title with custom underline */}
        <Box
          sx={{
            position: "fixed",
            top: { lg: "45px", xs: "205px" },
            display: "inline-block",
            textAlign: "center",
            paddingBottom: "10px",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              height: "20px",
              width: "100%",
              backgroundImage: `url(${Underline})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "contain",
            },
          }}
        >
          <Typography
            sx={{
              color: "#F04336",
              fontSize: { lg: "40px", xs: "30px" },
              fontFamily: "Nunito",
              fontWeight: 1000,
            }}
          >
            Contact Us
          </Typography>
        </Box>
        {/* Book Now Details */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "50px",
            backgroundColor: "#F04336",
            padding: "20px 60px 20px 60px",
            borderRadius: "20px",
            textAlign: "center",
            gap: "20px",
            width: { xs: "300px", md: "500px" },
          }}
        >
          <TextField
            placeholder="First Name"
            id="standard-basic"
            label="First Name"
            variant="standard"
            value={formData.firstName}
            onChange={handleChange("firstName")}
            sx={{
              width: "100%",
              input: {
                color: "white", // input text
                fontFamily: "Nunito",
              },
              label: {
                color: "white", // default label
                fontFamily: "Nunito",
                fontWeight: 800,
              },
              "& label.Mui-focused": {
                color: "white", // floating label on focus
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "white", // default underline
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "white", // underline on focus
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "white", // underline on hover
              },
            }}
          />
          <TextField
            placeholder="Last Name"
            id="standard-basic"
            label="Last Name"
            value={formData.lastName}
            onChange={handleChange("lastName")}
            variant="standard"
            sx={{
              width: "100%",
              input: {
                color: "white", // input text
                fontFamily: "Nunito",
              },
              label: {
                color: "white", // default label
                fontFamily: "Nunito",
                fontWeight: 800,
              },
              "& label.Mui-focused": {
                color: "white", // floating label on focus
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "white", // default underline
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "white", // underline on focus
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "white", // underline on hover
              },
            }}
          />
          <TextField
            placeholder="Email"
            id="standard-basic"
            label="Email"
            variant="standard"
            value={formData.email}
            onChange={handleChange("email")}
            sx={{
              width: "100%",
              input: {
                color: "white", // input text
                fontFamily: "Nunito",
              },
              label: {
                color: "white", // default label
                fontFamily: "Nunito",
                fontWeight: 800,
              },
              "& label.Mui-focused": {
                color: "white", // floating label on focus
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "white", // default underline
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "white", // underline on focus
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "white", // underline on hover
              },
            }}
          />
          <TextField
            placeholder="Contact Number"
            id="standard-basic"
            label="Contact Number"
            variant="standard"
            value={formData.contactNumber}
            onChange={handleChange("contactNumber")}
            sx={{
              width: "100%",
              input: {
                color: "white", // input text
                fontFamily: "Nunito",
              },
              label: {
                color: "white", // default label
                fontFamily: "Nunito",
                fontWeight: 800,
              },
              "& label.Mui-focused": {
                color: "white", // floating label on focus
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "white", // default underline
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "white", // underline on focus
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "white", // underline on hover
              },
            }}
          />
          <TextField
            placeholder="Message"
            id="standard-basic"
            label="Message"
            variant="standard"
            value={formData.message}
            onChange={handleChange("message")}
            multiline
            minRows={4} // you can adjust this number
            fullWidth
            sx={{
              textarea: {
                color: "white", // this targets the actual multiline <textarea>
              },
              input: {
                color: "white", // input text
                fontFamily: "Nunito",
              },
              label: {
                color: "white", // default label
                fontFamily: "Nunito",
                fontWeight: 800,
              },
              "& label.Mui-focused": {
                color: "white", // floating label on focus
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "white",
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "white",
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "white",
              },
            }}
          />
          {/* <Button
          variant="contained"
          sx={{
            backgroundColor: "white",
            color: "#F04336",
            padding: "10px 20px",
            fontSize: "15px",
            fontWeight: "bold",
            border: "1px solid #F04336",
          }}
        >
          Send Message
        </Button> */}
          <Box
            onClick={handleSubmit}
            sx={{
              height: "50px", // or whatever you need
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={SendMessage}
              alt="SendMessage"
              style={{
                height: "100%",
                width: "auto", // maintain aspect ratio
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
        {/*Contact Information*/}
        <Box
          sx={{
            width: { xs: "70%", md: "90%" },

            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            alignItems: "flex-start",
            backgroundColor: "#F04336",
            marginTop: "20px",
            borderRadius: "12px",
            padding: "20px",
          }}
        >
          {/*Location Details*/}
          <Box
            sx={{
              width: { xs: "100%", md: "33.3%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "white",

                marginBottom: "20px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
                fontSize: "30px",
                fontFamily: "Nunito",
                fontWeight: 900,
              }}
            >
              Location
            </Typography>
            <Typography
              sx={{
                color: "white",
                marginBottom: "20px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
                fontSize: "18px",
                fontFamily: "Nunito",
                fontWeight: 600,
              }}
            >
              22 Dart Street <br />
              Ashton-On-Ribble <br />
              Preston, PR2 1AY
            </Typography>
          </Box>
          {/*Working Hours*/}
          <Box
            sx={{
              width: { xs: "100%", md: "33.3%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "white",
                marginBottom: "20px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
                fontSize: "30px",
                fontFamily: "Nunito",
                fontWeight: 900,
              }}
            >
              Working Hours
            </Typography>
            <Typography
              sx={{
                color: "white",
                marginBottom: "20px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
                fontSize: "18px",
                fontFamily: "Nunito",
                fontWeight: 600,
              }}
            >
              Mon-Fri: 08:00 - 20:00 <br />
              Sat-Sun: 10:00 - 18:00
            </Typography>
          </Box>
          {/*Contact Details*/}
          <Box
            sx={{
              width: { xs: "100%", md: "33.3%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "white",
                marginBottom: "20px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
                fontSize: "30px",
                fontFamily: "Nunito",
                fontWeight: 900,
              }}
            >
              Contact Details
            </Typography>
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
                marginBottom: "10px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px", // spacing between icon and text
                  fontSize: "18px",
                  fontFamily: "Nunito",
                  fontWeight: 600,
                }}
              >
                <img src={Phone} alt="phone" width="20px" height="20px" />
                07868 661302
              </Box>
            </Typography>
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
                marginBottom: "10px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px", // spacing between icon and text
                  fontSize: "18px",
                  fontFamily: "Nunito",
                  fontWeight: 600,
                }}
              >
                <img src={Phone} alt="phone" width="20px" height="20px" />
                01772 460370
              </Box>
            </Typography>
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
                marginBottom: "20px", // add margin at the bottom of the title
                width: "100%",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px", // spacing between icon and text
                  fontSize: "18px",
                  fontFamily: "Nunito",
                  fontWeight: 600,
                }}
              >
                <img src={Mail} alt="phone" width="20px" height="20px" />
                kimbospaws@gmail.com
              </Box>
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "20px" }}>
              <Box>
                <img src={Facebook} alt="Facebook" />
              </Box>
              <Box>
                <img src={Instagram} alt="Instagram" />
              </Box>
            </Box>
          </Box>
        </Box>
        <form
          ref={formRef}
          action="https://formsubmit.co/kimbospaws@gmail.com" // <-- replace with your email
          method="POST"
          style={{ display: "none" }}
        >
          <input type="hidden" name="First Name" value={formData.firstName} />
          <input type="hidden" name="Last Name" value={formData.lastName} />
          <input type="hidden" name="Email" value={formData.email} />
          <input
            type="hidden"
            name="Contact Number"
            value={formData.contactNumber}
          />
          <input type="hidden" name="Message" value={formData.message} />
          <input type="hidden" name="_captcha" value="false" />
          <input
            type="hidden"
            name="_autoresponse"
            value="Thanks for contacting us!"
          />
          <input type="hidden" name="_template" value="table" />
          <input
            type="hidden"
            name="_subject"
            value="New Contact Form Submission"
          />
        </form>
      </Box>
    </Box>
  );
}
